var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.mutableValue,
        expression: "mutableValue",
      },
    ],
    ref: "timePicker",
    staticClass: "form-control text-center text-lg-left",
    class: { "disabled-input": _vm.disabled },
    attrs: { type: "text" },
    domProps: { value: _vm.mutableValue },
    on: {
      input: function ($event) {
        if ($event.target.composing) return
        _vm.mutableValue = $event.target.value
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }